import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';
import { apiLoaderQuery } from 'store/query';

const tagType = 'Gender Bitwerx';

export const genderBitwerxApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'genderBitwerxApi',
  endpoints: (build) => ({
    list: build.query<any[], any>({
      providesTags: () => [tagType],
      transformResponse: (response: any) => response.data.sexes,
      query: (data: any) => ({
        method: 'get',
        url: generateUrl(URL.GET_BITWERX_GENDER_MASTER_LIST, { id: data.id }),
      }),
    }),
  }),
});

export const { useListQuery } = genderBitwerxApi;
